import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import RadioGroupRating from './RadioGroupRating';
import ClientProvider from './client';
export default createDemo(import.meta.url, RadioGroupRating, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/rating/demos/radio-group/RadioGroupRating.tsx",
    "fileName": "RadioGroupRating.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Rating from '@mui/material/Rating';\nimport type { IconContainerProps } from '@mui/material/Rating';\nimport SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';\nimport SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';\nimport SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';\nimport SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';\nimport SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';\n\nconst StyledRating = styled(Rating)(({ theme }) => ({\n  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {\n    color: (theme.vars || theme).palette.action.disabled,\n  },\n}));\n\nconst customIcons: {\n  [index: string]: {\n    icon: React.ReactElement<unknown>;\n    label: string;\n  };\n} = {\n  1: {\n    icon: <SentimentVeryDissatisfiedIcon color=\"error\" />,\n    label: 'Very Dissatisfied',\n  },\n  2: {\n    icon: <SentimentDissatisfiedIcon color=\"error\" />,\n    label: 'Dissatisfied',\n  },\n  3: {\n    icon: <SentimentSatisfiedIcon color=\"warning\" />,\n    label: 'Neutral',\n  },\n  4: {\n    icon: <SentimentSatisfiedAltIcon color=\"success\" />,\n    label: 'Satisfied',\n  },\n  5: {\n    icon: <SentimentVerySatisfiedIcon color=\"success\" />,\n    label: 'Very Satisfied',\n  },\n};\n\nfunction IconContainer(props: IconContainerProps) {\n  const { value, ...other } = props;\n  return <span {...other}>{customIcons[value].icon}</span>;\n}\n\nexport default function RadioGroupRating() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <StyledRating\n      name=\"highlight-selected-only\"\n      defaultValue={2}\n      getLabelText={(value: number) => customIcons[value].label}\n      slotProps={{ icon: { component: IconContainer } }}\n      highlightSelectedOnly\n    />\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 7,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { styled } from '@mui/material/styles';\nimport Rating from '@mui/material/Rating';\nimport type { IconContainerProps } from '@mui/material/Rating';\nimport SentimentVeryDissatisfiedIcon from '@mui/icons-material/SentimentVeryDissatisfied';\nimport SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';\nimport SentimentSatisfiedIcon from '@mui/icons-material/SentimentSatisfied';\nimport SentimentSatisfiedAltIcon from '@mui/icons-material/SentimentSatisfiedAltOutlined';\nimport SentimentVerySatisfiedIcon from '@mui/icons-material/SentimentVerySatisfied';\n\nconst StyledRating = styled(Rating)(({ theme }) => ({\n  '& .MuiRating-iconEmpty .MuiSvgIcon-root': {\n    color: (theme.vars || theme).palette.action.disabled,\n  },\n}));\n\nconst customIcons: {\n  [index: string]: {\n    icon: React.ReactElement<unknown>;\n    label: string;\n  };\n} = {\n  1: {\n    icon: <SentimentVeryDissatisfiedIcon color=\"error\" />,\n    label: 'Very Dissatisfied',\n  },\n  2: {\n    icon: <SentimentDissatisfiedIcon color=\"error\" />,\n    label: 'Dissatisfied',\n  },\n  3: {\n    icon: <SentimentSatisfiedIcon color=\"warning\" />,\n    label: 'Neutral',\n  },\n  4: {\n    icon: <SentimentSatisfiedAltIcon color=\"success\" />,\n    label: 'Satisfied',\n  },\n  5: {\n    icon: <SentimentVerySatisfiedIcon color=\"success\" />,\n    label: 'Very Satisfied',\n  },\n};\n\nfunction IconContainer(props: IconContainerProps) {\n  const { value, ...other } = props;\n  return <span {...other}>{customIcons[value].icon}</span>;\n}\n\nexport default function RadioGroupRating() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <StyledRating\n      name=\"highlight-selected-only\"\n      defaultValue={2}\n      getLabelText={(value: number) => customIcons[value].label}\n      slotProps={{ icon: { component: IconContainer } }}\n      highlightSelectedOnly\n    />\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 52
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledRating"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "name"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "highlight-selected-only",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "defaultValue"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-c1 di-num",
                "2"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 55
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "getLabelText"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "(",
              [
                "span",
                "pl-v di-jv",
                "value"
              ],
              [
                "span",
                "pl-k di-pu",
                ":"
              ],
              " ",
              [
                "span",
                "pl-c1 di-bt",
                "number"
              ],
              ") ",
              [
                "span",
                "pl-k di-pu",
                "=>"
              ],
              " ",
              [
                "span",
                "pl-smi di-jv",
                "customIcons"
              ],
              "[",
              [
                "span",
                "pl-smi di-jv",
                "value"
              ],
              "].",
              [
                "span",
                "pl-c1 di-jv",
                "label"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "slotProps"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "{ ",
              [
                "span",
                "di-op di-jv",
                "icon"
              ],
              ": { ",
              [
                "span",
                "di-op di-jv",
                "component"
              ],
              ": ",
              [
                "span",
                "pl-smi di-jv",
                "IconContainer"
              ],
              " } }",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "      ",
              [
                "span",
                "pl-e di-ak",
                "highlightSelectedOnly"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 58
            },
            "    />"
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 60,
    "focusedLines": 7,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Rating",
      "@mui/icons-material/SentimentVeryDissatisfied",
      "@mui/icons-material/SentimentDissatisfied",
      "@mui/icons-material/SentimentSatisfied",
      "@mui/icons-material/SentimentSatisfiedAltOutlined",
      "@mui/icons-material/SentimentVerySatisfied"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
